/* Apparition douce des blocs à l'arrivée dans l'écran.

   La classe qui masque est posée par ce script : sans JavaScript, ou si la
   personne a demandé moins d'animations, la page reste entièrement visible.
*/

(function initReveal() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  /* Les éléments qui gagnent à entrer en scène, sans toucher à l'en-tête
     ni aux zones qui doivent rester stables au chargement. */
  const SELECTORS = [
    '.sirito-section-head',
    '.sirito-products__row > *',
    '.sirito-products__grid > *',
    '.sirito-collections__head',
    '.sirito-collections__card',
    '.sirito-usp__item',
    '.sirito-promise__card',
    '.sirito-feature__text',
    '.sirito-timeline__intro',
    '.sirito-timeline__step',
    '.sirito-faq__intro',
    '.sirito-faq__item',
    '.sirito-ugc__head',
    '.sirito-ugc__row > *',
    '.sirito-fruits__item',
    // La barre du journal arrive avant les cartes : elle donne le départ.
    '.sirito-blog__toolbar',
    '.sirito-blog__card',
    // Page d'article : la couverture et la sortie de page s'animent, jamais
    // le corps du texte — on ne masque pas ce qu'on vient lire.
    '.sirito-article__cover',
    '.sirito-article__nav-slot',
    '.sirito-article__related-card',
    '.sirito-collection__grid > *',
    '.sirito-contact__intro',
    '.sirito-contact__row',
    '.sirito-newsletter__inner > *',
  ];

  const targets = document.querySelectorAll(SELECTORS.join(','));
  if (!targets.length) return;

  let observed = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observed = true;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    // On déclenche un peu avant l'entrée réelle : l'animation est finie
    // quand le regard arrive dessus.
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  /* Filet de sécurité : du contenu masqué qui ne se révélerait jamais serait
     bien pire qu'une animation manquée.

     Il ne suffit pas de vérifier qu'aucune observation n'a eu lieu : si
     l'observateur s'arrête après avoir traité les premiers éléments, les
     suivants resteraient invisibles pour toujours. On repasse donc à deux
     reprises et on affiche tout ce qui est déjà entré dans l'écran. */
  const rattraper = () => {
    targets.forEach((el) => {
      if (el.classList.contains('is-revealed')) return;
      if (!observed || el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('is-revealed');
        observer.unobserve(el);
      }
    });
  };

  window.setTimeout(rattraper, 2500);
  window.setTimeout(rattraper, 6000);

  /* Décalage entre voisins d'une même rangée.

     Le compte était mené sur l'ordre global, remis à zéro tous les six
     éléments : sur une grille de trois colonnes, la remise à zéro tombait au
     milieu d'une rangée et la troisième carte partait avant ses voisines.

     On regroupe donc par position verticale : chaque rangée repart de zéro et
     se dévoile de gauche à droite, quel que soit le nombre de colonnes. Le
     plafond évite qu'une longue rangée ne fasse trop attendre sa fin. */
  const rangees = new Map();
  targets.forEach((el) => {
    // Arrondi au dizième de pixel près : deux cartes d'une même rangée ne
    // partagent pas toujours un sommet strictement identique.
    const cle = Math.round(el.getBoundingClientRect().top + window.scrollY) / 10;
    const rang = Math.round(cle);
    if (!rangees.has(rang)) rangees.set(rang, 0);
    const position = rangees.get(rang);
    rangees.set(rang, position + 1);

    el.classList.add('sirito-reveal');
    const delay = Math.min(position, 5) * 60;
    if (delay) el.style.setProperty('--reveal-delay', `${delay}ms`);
    observer.observe(el);
  });
})();
